<template>
<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <!-- <a class="navbar-brand" href="#">Navbar</a> -->
  <router-link to="/stockhome" class="navbar-brand">MyRunDash</router-link>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item">
        <!-- <a class="nav-link" href="#">Home <span class="sr-only">(current)</span></a> -->
        <router-link to="/portfolio" class="nav-link" activeClass="active">Portfolio</router-link>
      </li>
      <li class="nav-item">
        <router-link to="/stocks" class="nav-link" activeClass="active">Stocks</router-link>
      </li>
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Dropdown
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a class="dropdown-item" href="#">Save Date</a>
          <a class="dropdown-item" href="#">Load Data</a>
        </div>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#" tabindex="-1" @click="endDay">End Day</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#" tabindex="-1" @click="saveData">Save Data</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#" tabindex="-1" @click="loadData">Load Data</a>
      </li>
    </ul>
    <form class="form-inline my-2 my-lg-0">
      <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
      <button class="btn btn-outline-success my-2 my-sm-0 mr-2" type="submit">Search</button>
    </form>
    {{ funds | currency }}
  </div>
</nav>
</template>

<script>

  import {mapActions} from 'vuex'; // Lecture 297

  export default {
    data () {
      return {
        isDropdownOpen: false,
      }
    },
    computed: {
      funds() {
        return this.$store.getters.funds;
      }
    },
    methods: {
      ...mapActions({
        randomizeStocks: 'randomizeStocks',
        fetchData: 'loadData',
      }),
      endDay () {
        this.randomizeStocks();
      },
      saveData() {
        const data = {
          funds: this.$store.getters.funds,
          stockPortfolio: this.$store.getters.stockPortfolio,
          stocks: this.$store.getters.stocks,
        };
        this.$http.put('stockdata.json', data);
      },
      loadData() {
        console.log('Loading Data');
        this.fetchData();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/HeaderStocks.vue